import {Entity} from '../base/entity';
import {Specifikacija} from '../nabavke/specifikacija';

export class Item extends Entity {
  public static readonly TABLENAME = 'item';

  public static readonly ID = 'id';
  public static readonly GROUP_ID = 'group_id';
  public static readonly ITEM_NAME = 'item_name';
  public static readonly CODE = 'code';
  public static readonly ABBREVIATION = 'abbreviation';
  public static readonly UNIT_ID = 'unit_id';
  public static readonly PARITY_UNIT = 'parity_unit';
  public static readonly STOCK_NO = 'stock_no';
  public static readonly BARCODE = 'barcode';
  public static readonly EXTERNAL_CODE = 'external_code';
  public static readonly TAX_RATE_ID = 'tax_rate_id';
  public static readonly COST_LOCATION = 'cost_location';
  public static readonly COST_ITEM = 'cost_item';
  public static readonly WARRANTY_PERIOD = 'warranty_period';
  public static readonly PLU = 'plu';
  public static readonly COMPANY_ID = 'company_id';
  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';
  public static readonly OPERATION_ID = 'operation_id';
  public static readonly ISDELETED = 'isDeleted';
  public static readonly SERIAL_NO_TYPE = 'serialNoType';
  public static readonly SERIAL_NO_COUNT = 'serialNoCount';
  public static readonly SERIAL_NO_MASK = 'serialNoMask';
  // public static readonly OSNOVNO_SREDSTVO_ID = 'osnovnoSredstvoId';

  id: string;
  groupId: number;
  itemName: string;
  code: string;
  abbreviation: string;
  unitId: number;
  parityUnit: number;
  stockNo: string;
  barcode: string;
  externalCode: string;
  taxTariffId: number;
  costLocation: string;
  costItem: string;
  warrantyPeriod: string;
  plu: string;
  companyId: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  serialNoType: string;
  serialNoCount: number;
  serialNoMask: string;
  operationId: number;
  isDeleted: boolean;


  itemGroup: string;
  unitName: string;
  taxTariffCode: string;

  documentItems: any[];

  types: number[];
  itemTypes?: any[];

  // za prikaz stavki iz odgovarajuceg magacina
  stockroomId: string;
  quantity: number;
  transitionQuantity: number;
  reservedQuantity: number;
  stockMin: number;
  stockMax: number;
  pp: number;
  vat: number;
  price: number;
  osnovnoSredstvoId: number;

  cartQuantity: number = 0;

  pozicija: boolean;
  specifikacija: Specifikacija;
}
